import { makeApiUrl } from '../http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { RemoteGetQboAccounts } from '../../../data/usecases/remote-get-qbo-accounts';
import { GetQboAccounts } from '../../../domain/usecases/get-qbo-accounts';

export const makeRemoteGetQboAccounts = (): GetQboAccounts => {
  return new RemoteGetQboAccounts(makeApiUrl('/accounts'), makeAuthorizeHttpClientDecorator());
};
